// extracted by mini-css-extract-plugin
export default {"dropdown":"menu_dropdown__CCpjF","item":"menu_item__Sdpzl","itemSection":"menu_itemSection__66VuW","label":"menu_label__rw4Xp"};